const eCircleProgressStep = {
    props: {
        stepNumber: {
            default: "1",
        },
        activePerc: {
            type: Number,
            default: 0,
        },
        completePerc: {
            type: Number,
            default: 0,
        },
        isJump:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            max:120,
            activeValue: 0,
            completeValue: 0
        }
    },
    template: `
<div class="e-circle-progress-step" :class="completedClass">
    <svg ref="svg" width="40" height="40" viewbox="0 0 100 100" style="transform: rotate(-90deg);">
        <circle class="e-circle-progress-step__circle-bg" r="19" cx="20" cy="20">
        </circle>
        <circle class="e-circle-progress-step__circle-active" r="19" cx="20" cy="20" :stroke-dasharray="max" :stroke-dashoffset="activeValue">
        </circle>
        <circle class="e-circle-progress-step__circle-complete" r="19" cx="20" cy="20" :stroke-dasharray="max" :stroke-dashoffset="completeValue">
        </circle>
    </svg>
    <span v-if="!isJump" class="e-circle-progress-step__txt">{{stepNumber}}</span>
    <span v-else class="e-circle-progress-step__jump"></span>
    <span role="presentation" class="e-circle-progress-step__complete"></span>
</div>`,
    mounted(){
        this.setActiveValue(0)
        this.setCompleteValue(0)        
    },
    methods:{
        calcVal(perc){
            return this.max  - (perc * this.max) / 100
        },
        setActiveValue(perc){
            this.activeValue = this.calcVal(perc)   
        },
        setCompleteValue(perc){
            this.completeValue = this.calcVal(perc)   
        },
        
    },
    computed:{
        completedClass(){
            if(this.completePerc===100){
                return 'e-circle-progress-step--completed'
            }
            return ''
        }
    },
    watch: {
        activePerc: {
            handler(val, oldVal) {
                setTimeout(()=>{
                    this.setActiveValue(this.activePerc)
                },500)
            },
            immediate: true
        },
        completePerc: {
            handler(val, oldVal) {
                setTimeout(()=>{
                    this.setCompleteValue(this.completePerc)
                },500)
            },
            immediate: true
        },
    },
};
